import React from "react";
import clsx from "clsx";
import { connect, ConnectedProps } from "react-redux";

interface ThemeOptionsState {
  footerShadow: boolean;
  footerBgTransparent: boolean;
}
interface RootState {
  ThemeOptions: ThemeOptionsState;
  [key: string]: any;
}

const mapStateToProps = (state: RootState) => ({
  footerShadow: state.ThemeOptions.footerShadow,
  footerBgTransparent: state.ThemeOptions.footerBgTransparent
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const Footer: React.FC<PropsFromRedux> = ({ footerShadow, footerBgTransparent }) => {
  return (
    <div
      className={clsx("app-footer text-black-50", {
        "app-footer--shadow": footerShadow,
        "app-footer--opacity-bg": footerBgTransparent
      })}
    >
    </div>
  );
};

export default connector(Footer);
